import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/transitional/components/View';
import { useEffect, useState } from 'react';
import SnippetPopoverBodyBase from './SnippetPopoverBodyBase';
import SnippetPopoverError from './SnippetPopoverError';
import SnippetPopoverHeader from './SnippetPopoverHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SnippetPopoverBody({
  fetchSnippets,
  onInsert
}) {
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [searched, setSearched] = useState(false);
  const [snippets, setSnippets] = useState([]);
  const [queryInput, setQueryInput] = useState('');
  const updateSnippets = data => {
    let snippetData = [];
    if (data) {
      snippetData = data.results.map(res => {
        return {
          name: res.name,
          body: res.metadata.body,
          html: res.metadata.htmlBody
        };
      });
    }
    setSnippets(snippetData);
  };
  useEffect(() => {
    const queryOptions = {
      query: queryInput,
      limit: 1000,
      offset: 0
    };
    fetchSnippets(queryOptions).then(data => {
      setLoading(false);
      if (!data) {
        console.warn(`Could not fetch Snippets for this user`);
      }
      updateSnippets(data);
      setHasError(false);
      return data;
    }).catch(serverError => {
      setLoading(false);
      console.warn(serverError.message);
      setHasError(true);
      throw new Error(serverError.message);
    });
  }, [queryInput, fetchSnippets]);
  const renderSnippetPopover = () => {
    if (hasError) {
      return /*#__PURE__*/_jsx(SnippetPopoverError, {});
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SnippetPopoverHeader, {}), /*#__PURE__*/_jsx(SnippetPopoverBodyBase, {
        setQueryInput: setQueryInput,
        snippets: snippets,
        onInsert: onInsert,
        setSearched: setSearched,
        searched: searched
      })]
    });
  };
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "400px",
    padding: "500",
    tabIndex: -1,
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium"
    }) : renderSnippetPopover()
  });
}